import posthog from 'posthog-js'
import { errorAnalyticsPayload } from './errorAnalytics'
// Provider-agnostic event tracking utility
export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  try {
    posthog.capture(eventName, properties)
  } catch (error) {
    // Log error but don't throw - analytics shouldn't break the app
    console.error('PostHog event tracking failed:', errorAnalyticsPayload(error))
  }
}
